import { useCreate } from '@refinedev/core';
import { CalendarPlatform } from 'src/meetings/models';

export const useStartRemoteDocsConnectionOAuthMutation = () => {
  const { mutateAsync, isLoading, isError } = useCreate<{ url: string }>();

  const startOAuth = async (platform: CalendarPlatform) => {
    const response = await mutateAsync({
      resource: 'remote-docs-connections/start-oauth-flow',
      values: {
        platform,
      },
    });

    return response.data;
  };

  return {
    startOAuth,
    isLoading,
    isError,
  };
};
